const useGeolocation = () => {
	const getLocation = async () => {
		if (!navigator.geolocation) {
			console.error("Geolocation is not supported by your browser");
			return false;
		}

		return new Promise((resolve) => {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					resolve({
						acc: position.coords.accuracy,
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					});
				},
				(error) => {
					console.error("Error getting location:", error.message);
					resolve(false);
				},
				{ enableHighAccuracy: true, timeout: 200000, maximumAge: 0 }
			);
		});
	};

	return getLocation;
};

export default useGeolocation;
